import { render } from "./term.vue?vue&type=template&id=4cdd1f26&scoped=true"
const script = {}

import "./term.vue?vue&type=style&index=0&id=4cdd1f26&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdd1f26"]])

export default __exports__